import React, { useEffect, useCallback } from 'react'
import { AnimatePresence, useAnimation } from 'framer-motion'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { siteData as siteDataState } from '../store/dataStore'
import {
  currentSection as currentSectionState,
  currentFix as currentFixState,
  lastSection as lastSectionState,
  selectedClients as selectedClientsState,
} from '../store/uiStore'

import {
  LogoWrapper,
  LogoIconWrapper,
  LogoTextWrapper,
} from '../styles/globalStyles'

import LogoIcon from '../assets/svg/LogoIcon'
import LogoText from '../assets/svg/LogoText'

const Logo = () => {
  const siteData = useRecoilValue(siteDataState)
  const [currentSection, setCurrentSection] = useRecoilState(
    currentSectionState 
  )
  const setLastSection = useSetRecoilState(
    lastSectionState
  )
  const setCurrentFix = useSetRecoilState(
    currentFixState
  )
  const [selectedClients, setSelectedClients] = useRecoilState(
    selectedClientsState
  )
  const sections = ['servicios', 'distinciones', 'not-found']
  const rotateIcon = useAnimation()

  const logoIconVars = {
    initial: {
      rotate: 0,
    },
    rotate: {
      rotate: [0, 360],
      transition: {
        duration: 1.5,
        ease: 'easeOut',
      },
    },
  }

  const handleClick = useCallback(() => {
    if (currentSection !== 'quienes-somos') {
      if (currentSection === 'clientes') {
        setLastSection((last) => selectedClients === 0 ? 'clientes' : 'aliados')
        setSelectedClients((last) => 0)
      } else {
        setLastSection((last) => currentSection)
      }
      setCurrentSection((last) => 'quienes-somos')
      setCurrentFix((last) => 'quienes-somos')
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  useEffect(() => {
    rotateIcon.start('rotate')
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [currentSection])

  return (
    <AnimatePresence>
      {!['intro', 'servicio', 'miembro'].includes(currentSection) && (
        <LogoWrapper
          onClick={() => handleClick()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{
            opacity: 0,
            transition: {
              duration: 1,
              ease: 'linear',
            },
          }}
          transition={{ duration: 1, ease: 'easeOut' }}>
          <LogoIconWrapper
            className='icon'
            initial='initial'
            animate={rotateIcon}
            variants={logoIconVars}>
            <LogoIcon isWhite={sections.includes(currentSection)} />
          </LogoIconWrapper>
          <LogoTextWrapper>
            <LogoText isWhite={sections.includes(currentSection)} />
          </LogoTextWrapper>
          <h1>
            {siteData.name}
            <span>{siteData.tagline}</span>
          </h1>
        </LogoWrapper>
      )}
    </AnimatePresence>
  )
}

export default Logo
